import { render, staticRenderFns } from "./CommonOptionEdit.vue?vue&type=template&id=0c5aa20a&scoped=true"
import script from "./CommonOptionEdit.vue?vue&type=script&lang=js"
export * from "./CommonOptionEdit.vue?vue&type=script&lang=js"
import style0 from "./CommonOptionEdit.vue?vue&type=style&index=0&id=0c5aa20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5aa20a",
  null
  
)

export default component.exports